import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Sound from '@/views/Sound.vue'
import Sensory from '@/views/Sensory.vue'
import Harmonics from '@/views/Harmonics.vue'
import Scales from '@/views/Scales.vue'
import Chords from '@/views/Chords.vue'
import Progressions from '@/views/Progressions.vue'
import References from '@/views/References.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/scales'
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/sound',
      name: 'sound',
      component: Sound
    },
    {
      path: '/sensory',
      name: 'sensory',
      component: Sensory
    },
    {
      path: '/harmonics',
      name: 'harmonics',
      component: Harmonics
    },
    {
      path: '/scales',
      name: 'scales',
      component: Scales
    },
    {
      path: '/chords',
      name: 'chords',
      component: Chords
    },
    {
      path: '/refernces',
      name: 'references',
      component: References
    },
    {
      path: '/progressions',
      name: 'progressions',
      component: Progressions
    }
  ]
})
